/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedRelatedCreators_itemSearch = {
    readonly meta: {
        readonly attributeDisplayName: string | null;
    } | null;
    readonly topCategoryL1: VerticalType | null;
    readonly relatedCreators: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly linkData: {
                    readonly path: string | null;
                };
                readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedCreator_relatedCreators">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_itemSearch">;
    readonly " $refType": "SbSharedRelatedCreators_itemSearch";
};
export type SbSharedRelatedCreators_itemSearch$data = SbSharedRelatedCreators_itemSearch;
export type SbSharedRelatedCreators_itemSearch$key = {
    readonly " $data"?: SbSharedRelatedCreators_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedCreators_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRelatedCreators_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "attributeDisplayName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedCreators",
      "storageKey": null,
      "args": null,
      "concreteType": "relatedCreatorsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "relatedCreatorsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "RelatedCreatorType",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "SbSharedRelatedCreator_relatedCreators",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '973302aac183c23b00e85cb50bcce0c3';
export default node;
